import React from 'react'
import vision from '../Image/vision.webp'
function Our_vision() {
  return (
    <div>
      {/* ------------------------------Mobile View--------------------------- */}
      <div className="d-sm-block d-md-none ">
        <div className="container-fluid pt-3">
          <div className="row">
            <div className="col-md-12">
              <img
                className="vision_img"
                src={vision}
                alt="Vision of InternsElite"
                title="Vision of InternsElite"
                onContextMenu={(e) => e.preventDefault()}
              ></img>
            </div>
            <div className="col-md-12">
              <div className="pt-4 vision_text vision_text_mobile  text-center">
                <h2 className="display-5 pb-1">Our Vision:</h2>
                <p>
                  We think that education has the power to genuinely change lives; we work to become a global hub for advanced learning. Our goal is to give students the abilities, real-world experience, and flexibility they need to succeed in their chosen fields. Our goal is to create a world where learning is a potent driver of development, innovation, and constructive change by fostering creativity, critical thinking, and practical knowledge.
                </p>
              </div>
              <div className="vision_text vision_text_mobile pt-4 text-center border-bottom pb-3">
                <h2 className="display-5 pb-1">Our Mission:</h2>
                <p>
                  Empower individuals through cutting-edge education, offering
                  advanced courses and traineeships that transcend traditional
                  boundaries. We strive to cultivate a dynamic learning
                  environment, fostering skill development and innovation to
                  propel our learners towards success in the ever-evolving
                  landscape of knowledge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------Desktop View-------------------------------- */}
      <div className="d-none d-md-block mb-2">
        <div className="container-fluid pt-4">
          <div className="row">
            <div className="col-xl-6">
              <div className="pt-5 px-5 vision_text">
                <h2 className="display-5 pb-2">Our Vision:</h2>
                <p>
                  We want to be a global centre for advanced learning because we believe that education can change lives. Our goal is to give students the skills and flexibility they need to do well in their chosen fields. This will help create a world where knowledge is a force for good and growth.

                </p>
              </div>
              <div className="vision_text px-5 pt-5 text-end">
                <h2 className="display-5 pb-2">Our Mission:</h2>
                <p>
                  Give people power through cutting-edge education by offering advanced courses and internships that go beyond what is usually available. We work hard to create a dynamic learning environment that encourages skill development and new ideas to help our students succeed in the ever-changing world of knowledge.
                </p>
              </div>
            </div>
            <div className="col-xl-6 pt-3">
              <img
                className="vision_img"
                src={vision}
                alt="Vision of InternsElite"
                title="Vision of InternsElite"
                onContextMenu={(e) => e.preventDefault()}
              ></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Our_vision
